var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-stepper',[_c('v-stepper-header',{staticClass:"stepper-header"},_vm._l((_vm.steps),function(step,index){return _c('StepperStep',{key:index,attrs:{"step":step,"show-divider":index < (_vm.steps.length-1)}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }